import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer, NewsArticleCard } from '../../components';
import _ from 'lodash';
import moment from 'moment';

class NewsDetail extends Component {

  state = {
    news: [],
    featuredNews: {},
  }

  componentDidMount = () => {
    fetch(`/en/news/json/${this.props.match.params.newsId}`)
      .then(response => {
        if(response.ok) {
          return response.json()
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(data => {
        this.setState({ 
          news: data.data,
          featuredNews: data.featuredNews
        })
      })
  }

  render() {
    const { news } = this.state;
    const currentLatestNews = _.last(this.state.news)
    return (
      <div className="news-container">
        <div className="container">
          <div className="news-detail-container">
            <div>
              <Link to="/en/news" className="back-to-main"> &lt; Back to news</Link>
            </div>
            <div className="news-detail-img-wrapper">
              <img alt="head-img" src={ _.get(news, 'media') }/>
            </div>
            <div className="article-title">{ _.get(news, 'title') }</div>
            <div className="article-date">{moment(_.get(news, 'createdAt.date')).format('MMMM D ,YYYY')}</div>
            <div dangerouslySetInnerHTML={{ __html: _.get(news, 'content') }} />
          </div>
          <h2 className="news-detail-latest-header">LATEST NEWS</h2>
          <div className="related-news-column">
            <NewsArticleCard 
              media={_.get(currentLatestNews, 'media')}
              title={_.get(currentLatestNews, 'title')}
              dateString={moment(_.get(currentLatestNews, 'createdAt.date')).format('MMMM D ,YYYY')}
              to={`/en/news/${_.get(currentLatestNews, 'id')}/${_.get(currentLatestNews, 'slug')}`}
              excerpt={_.get(currentLatestNews, 'excerpt')}
            />
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default NewsDetail;


// WEBPACK FOOTER //
// ./src/pages/News/NewsDetail.js